import { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { CardUpdatePortal } from '../cardUpdatePortal';
import './webchatCardUpdate.scss';
import { useAppDispatch } from 'store/hooks';
import { useLocation } from 'react-router';
import { getPaymentGuidFromUrl } from 'actions/index';
import { useGetScreenSize } from 'utils';
import { PaymentSuccessPage } from './paymentSuccessPage';
import { Title } from 'components/layout/header/title';

export const WebchatCardUpdate = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const { isMobile, isTablet } = useGetScreenSize();

  useEffect(() => {
    dispatch(getPaymentGuidFromUrl(pathname));
  }, [pathname]);

  return (
    <Container className="page-container" fluid={isMobile || isTablet}>
      <Title title="MANAGE PAYMENTS" icon="credit-card-circle" id="card-update" />
      <div className="payment-container">
        <CardUpdatePortal
          cardUpdateSuccessPage={<PaymentSuccessPage />}
          buttonText="Save"
          subHeadingText="EDIT YOUR CARD"
        />
      </div>
    </Container>
  );
};
